import React, { useEffect, useState } from "react";
//--------Material React Table------//
import {
  MaterialReactTable,
  MRT_ToolbarAlertBanner,
  useMaterialReactTable,
} from "material-react-table"; //material-react-table
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import Loader from "../Loader/Loader";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
function MaterialTableTreeComponent({
  columns,
  data,
  MainHeading,
  ReportHeading,
  startdate,
  enddate,
  columnGrouping,
  setColumnOrder,
  setColumnVisibility,
  state,
  columnPinning = {},
  columnsVisibility,
  hodiExport = false,
  isItemInventory = false,
  isdriverdailyreport = false,
  isRowSelectionManual = false,
  renderDetailPanel,
  muiExpandButtonProps,
  enableRowActions = false,
  // datafetch,
  // dataget,
  isdrivertasklist = false,
  setRowSelectData,
  isDriverReport = false,
  muiRowDragHandleProps = () => {},
  rowActionsType = "",
  renderRowActionMenuItems = () => [],
  renderRowActions = () => [],
  enableRowOrdering = false,
  enableRowSelection = true,
  expanded = false,
  // enableExpanding = false,
  enableExpandAll = false,
  groupedColumnMode = "remove", // remove, reorder, false
  muiTableContainerProps = { sx: { maxHeight: "fit-content" } },
  muiTableBodyRowProps = () => {},
  muiTableBodyCellProps = () => {},
  columnsToExport = [],
}) {
  const [loading, setLoading] = useState(false);
  const [groupedColumnModes, setGroupedColumnModes] = useState("remove");
  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    console.log(data, field, "41787");
    if (field == "isdriverdailyreport") {
      let newarr = [];

      let newobj = data?.map((item) => {
        return {
          Date: item?.Date,
          SaleType: item?.SaleType,
          InvoiceNo: item?.InvoiceNo,
          CompanyName: item?.CompanyName,
          Total: `$${item?.Total ? Number(item?.Total).toFixed(2) : "0.00"}`,
          Route: item?.Route,
        };
      });

      newarr.push(newobj);

      console.log(newarr[0]);

      const worksheet = XLSX.utils.json_to_sheet(newarr[0]);

      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Save the workbook as an Excel file
      XLSX.writeFile(workbook, `Exel_Report.xlsx`);
    } else {
      let Data = [];

      if (columnsToExport.length > 0) {
        // If specific columns are to be exported
        if (field === "AllData") {
          Data = data.map((el) => {
            let exportData = {};
            columnsToExport.forEach((col) => {
              if (col === "Date" && el.Date) {
                exportData[col] = moment(el.Date).format("MM-DD-YYYY");
              } else {
                exportData[col] = el[col] !== undefined ? el[col] : "";
              }
            });
            return exportData;
          });
        } else {
          // Data = filterData?.map((el) => el?.original);
          Data = filterData.map((el) => {
            let exportData = {};
            columnsToExport.forEach((col) => {
              if (col === "Date" && el?.original?.Date) {
                exportData[col] = moment(el?.original?.Date).format(
                  "MM-DD-YYYY"
                );
              } else {
                exportData[col] =
                  el?.original[col] !== undefined ? el?.original[col] : "";
              }
            });
            return exportData;
          });
        }
      } else {
        if (field === "AllData") {
          Data = data.map((el) => ({
            ...el, // Spread all other properties of the object
            Date: moment(el.Date).format("MM-DD-YYYY"), // Format the Date field
          }));
        } else {
          Data = filterData?.map((el) => el?.original);
        }
      }

      console.log(Data, "export pdf data");
      // Convert the data to a worksheet
      const worksheet = XLSX.utils.json_to_sheet(Data);

      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Save the workbook as an Excel file
      XLSX.writeFile(workbook, `Exel_Report.xlsx`);
    }
  };

  const downloadPDF = (rows, field, visibleColumns) => {
    console.log("visibleColumns=>", visibleColumns);
    let reportMainHeading = MainHeading;
    let reportHeading = ReportHeading;
    let reportDateHeading =
      startdate && enddate ? `From: ${startdate} To: ${enddate}` : "All Date";

    visibleColumns = visibleColumns.filter(
      (col) => col.columnDef.header !== "Select"
    );

    let newData = [];
    if (columnsToExport.length > 0) {
      // If specific columns are to be exported
      // toastSuccess("Exporting PDF started");
      if (field === "selectedrow") {
        // toastSuccess("Exporting PDF with selected columns");
        newData = rows.map((row) => {
          let exportData = {};
          columnsToExport.forEach((col) => {
            if (col === "Date" && row.original.Date) {
              exportData[col] = moment(row.original.Date).format("MM-DD-YYYY");
            } else {
              exportData[col] =
                row.original[col] !== undefined ? row.original[col] : "";
            }
          });
          return exportData;
        });
      } else if (field === "alldata") {
        // toastSuccess("Exporting PDF with all data");
        newData = data.map((el) => {
          let exportData = {};
          columnsToExport.forEach((col) => {
            const value = el[col];
            if (col === "Date" && value) {
              exportData[col] = moment(value).format("MM-DD-YYYY");
            } else if (value === undefined || value === null) {
              exportData[col] = "";
            } else {
              exportData[col] = value;
            }
          });
          return exportData;
        });
      }
    } else {
      if (field === "selectedrow") {
        newData = rows.map((row) => row.original);
      } else if (field === "alldata") {
        newData = data.map((el) => {
          return {
            ...el,
            OpenBalance:
              el.OpenBalance == null || el.OpenBalance === "NaN"
                ? ""
                : parseFloat(el.OpenBalance),
            ModifiedBy: el.ModifiedBy == null ? "" : el.ModifiedBy,
            DeliveryAddress:
              el.DeliveryAddress == null ? "" : el.DeliveryAddress,
          };
        });
      }
    }
    const doc = new jsPDF("p", "mm", "a4");

    let pageWidth = doc.internal.pageSize.width;
    let pageHeight = doc.internal.pageSize.height;

    let itemsPerPage = Math.floor(pageHeight); // Adjust the factor based on your content
    console.log("itemsPerPage=>", itemsPerPage);

    doc.setFontSize(10);

    for (
      let currentPage = 1, rowNumber = 1;
      rowNumber <= newData.length;
      currentPage++
    ) {
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = Math.min(currentPage * itemsPerPage, newData.length);

      // Dynamic header
      const header = [
        "No",
        ...visibleColumns.map((col) => col.columnDef.header),
      ];

      // Extract data for the current page
      const pageData = newData.slice(startIndex, endIndex);

      // Calculate header height
      const headerHeight = doc.getTextDimensions(header.join(" ")).h + 2;

      // Calculate startY for the first page, and for subsequent pages, consider header height
      const startY = currentPage === 1 ? 25 : headerHeight; // Adjust as needed

      // Build the table content
      const content = {
        startY: startY,
        head: [header],
        body: pageData.map((row) => {
          // Parse row data dynamically
          const parsedRow = visibleColumns.map((col) => {
            const dataValue = row[col.columnDef.id];
            let value = "";

            if (typeof dataValue === "number") {
              value = parseFloat(dataValue);
            } else if (typeof dataValue === "string") {
              value = dataValue;
            } else if (moment(dataValue).isValid()) {
              value = moment(dataValue).format("MM-DD-YYYY (HH:mm)");
            }

            return value;
          });

          return [rowNumber++, ...parsedRow];
        }),
        headStyles: { fillColor: [100, 100, 100] },
      };

      // Add the header on every page
      let textWidth =
        (doc.getStringUnitWidth(reportMainHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerX = (pageWidth - textWidth) / 2;
      doc.text(reportMainHeading, centerX, 10);

      let textWidthHeading =
        (doc.getStringUnitWidth(reportHeading) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXHeading = (pageWidth - textWidthHeading) / 2;
      doc.text(reportHeading, centerXHeading, 15);

      let textWidthDate =
        (doc.getStringUnitWidth(reportDateHeading) *
          doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      let centerXDate = (pageWidth - textWidthDate) / 2;
      doc.text(reportDateHeading, centerXDate, 20);

      doc.setPage(currentPage);
      doc.autoTable(content);

      // Add page break if not the last page
      if (currentPage < Math.ceil(newData.length / itemsPerPage)) {
        doc.addPage();
      }
    }

    doc.save(`${ReportHeading}.pdf`);
  };

const table = useMaterialReactTable({
  columns,
  data,
  getSubRows: (row) => row.children, // ✅ Correct place
  layoutMode: "semantic",
  columnSizing: {
    "mrt-row-select": 50,
    "mrt-row-actions": 50,
  },
  enableColumnResizing: true,
  enableGrouping: true,
  groupedColumnMode: groupedColumnModes,
  enableStickyHeader: true,
  enableStickyFooter: true,
  enableRowSelection: enableRowSelection,
  enableColumnOrdering: true,
  enableColumnPinning: true,
  sortDescFirst: true,
  enableColumnFilterModes: true,
  enablePagination: true,
  enableExpanding: true,
enableExpandAll: true,

  enableRowActions: enableRowActions,
  positionGlobalFilter: "left",
  positionToolbarAlertBanner: "none",
  muiTableBodyRowProps: muiTableBodyRowProps,
  muiTableBodyCellProps: muiTableBodyCellProps,
  ...(setColumnOrder && {
    onColumnOrderChange: setColumnOrder,
  }),
  ...(rowActionsType !== "menu"
    ? {
        renderRowActions: renderRowActions,
      }
    : {
        renderRowActionMenuItems: renderRowActionMenuItems,
      }),
  muiTableBodyProps: {
    sx: () => ({
      "& tr:nth-of-type(even)": {
        backgroundColor: "var(--datatable-row-background-color)",
      },
      "& td": {
        borderRight: "1px solid var(--datatable-row-background-hover-color)",
        lineHeight: "16px",
        fontWeight: "400",
        fontSize: "12px",
        color: "var(--primary-color-800)",
        fontFamily: "Inter",
      },
      "& tr": {
        lineHeight: "16px",
        fontWeight: "400",
        fontSize: "12px",
        color: "var(--primary-color-800)",
        fontFamily: "Inter",
      },
    }),
  },
  muiTableHeadCellProps: {
    sx: () => ({
      background: "var(--datatable-row-background-color)",
      borderRight: "1px solid var(--datatable-row-background-hover-color)",
      lineHeight: "16px",
      fontWeight: "500",
      fontSize: "14px",
      color: "var(--primary-color-800)",
      fontFamily: "Inter",
    }),
  },
  muiToolbarAlertBannerProps: {
    isError: () => ({
      color: "error",
      children: "Error loading data",
    }),
    sx: () => ({
      background: "var(--datatable-row-background-color)",
      lineHeight: "16px",
      fontWeight: "500",
      fontSize: "14px",
      color: "var(--primary-color-800)",
      fontFamily: "Inter",
    }),
  },
  muiSelectCheckboxProps: {
    sx: () => ({
      lineHeight: "16px",
      fontWeight: "400",
      fontSize: "12px",
      color: "var(--prinary-color-800)",
      fontFamily: "Inter",
    }),
  },
  muiSelectAllCheckboxProps: {
    sx: () => ({
      lineHeight: "16px",
      fontWeight: "400",
      fontSize: "12px",
      color: "var(--prinary-color-800)",
      fontFamily: "Inter",
    }),
  },
  muiTableContainerProps: muiTableContainerProps,
  muiPaginationProps: {
    rowsPerPageOptions: [50, 100, 300, 500, 1000],
  },
  initialState: {
    density: "compact",
    // expanded: expanded,
    grouping: columnGrouping,
    pagination: { pageIndex: 0, pageSize: 50 },
    showColumnFilters: false,
    columnPinning: columnPinning,
    columnVisibility: columnsVisibility,
    showGlobalFilter: true,
    expanded: true,
  },
  state: state,
  renderDetailPanel: renderDetailPanel,
  enableExpanding: true,
  enableExpandAll: enableExpandAll,
  muiExpandButtonProps: muiExpandButtonProps,
  ...(isDriverReport && {
    onRowSelectionChange: setRowSelectData,
    getRowId: (row) => row.Id,
  }),
  ...(isdriverdailyreport && {
    onRowSelectionChange: setRowSelectData,
    getRowId: (row) => row.saleID,
  }),
  ...(isRowSelectionManual && {
    onRowSelectionChange: setRowSelectData,
    getRowId: (row) => row.ID,
  }),
  enableRowOrdering: enableRowOrdering,
  muiRowDragHandleProps: muiRowDragHandleProps,
});

  return (
    <>
      <Loader loading={loading} />
      {/* <div id="PrintTable"> */}
      <DemoRadioGroup
        groupedColumnMode={groupedColumnModes}
        setGroupedColumnMode={setGroupedColumnModes}
      />
      <MRT_ToolbarAlertBanner table={table} />
      {!hodiExport && (
        <Box
          sx={{
            display: "flex",
            gap: "1rem",
            p: "0.5rem",
            flexWrap: "wrap",
          }}
        >
          <Button
            // size="small"
            className="btn btn-sm btn-secondary"
            style={{ display: "flex" }}
            color="primary"
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() => onBtExport([], "AllData")}
            startIcon={<FileDownloadIcon />}
            variant="contained"
          >
            Export All In Excel
          </Button>
          {columnsToExport?.length === 0 && (
            <Button
              // size="small"
              class="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              color="primary"
              //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
              onClick={() =>
                downloadPDF("", "alldata", table.getVisibleFlatColumns())
              }
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              EXPORT ALL IN PDF
            </Button>
          )}
          <Button
            // size="small"
            className="btn btn-sm btn-secondary"
            style={{ display: "flex" }}
            color="primary"
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() => onBtExport(table.getSelectedRowModel().rows, "")}
            startIcon={<FileDownloadIcon />}
            variant="contained"
            disabled={
              !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
            }
          >
            EXPORT SELECTED ROWS IN EXCEL
          </Button>
          {columnsToExport?.length === 0 && (
            <Button
              // size="small"
              class="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              disabled={
                !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
              }
              //only export selected rows
              onClick={() =>
                downloadPDF(
                  table.getSelectedRowModel().rows,
                  "selectedrow",
                  table.getVisibleFlatColumns()
                )
              }
              startIcon={<FileDownloadIcon />}
              variant="contained"
            >
              EXPORT SELECTED ROWS IN PDF
            </Button>
          )}
          <Button
            // size="small"
            className="btn btn-sm btn-secondary"
            style={{ display: "flex" }}
            color="primary"
            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
            onClick={() => onBtExport(table.getRowModel().rows, "")}
            startIcon={<FileDownloadIcon />}
            variant="contained"
          >
            Export Page Rows In Excel
          </Button>
          {columnsToExport?.length === 0 && (
            <Button
              disabled={table.getRowModel().rows.length === 0}
              //export all rows as seen on the screen (respects pagination, sorting, filtering, etc.)
              onClick={() =>
                downloadPDF(
                  table.getRowModel().rows,
                  "selectedrow",
                  table.getVisibleFlatColumns()
                )
              }
              class="btn btn-sm btn-secondary"
              style={{ display: "flex" }}
              variant="contained"
              startIcon={<FileDownloadIcon />}
            >
              Export Page Rows In Pdf
            </Button>
          )}
        </Box>
      )}
      <MaterialReactTable
        table={table} //only pass in table instead of all table options
        enableRowSelection
      />
    </>
  );
}

const DemoRadioGroup = ({ groupedColumnMode, setGroupedColumnMode }) => {
  return (
    <>
      <div className="d-flex justify-content-center">
        <FormControl sx={{ margin: "auto", textAlign: "center" }}>
          <strong>Grouped Column Mode</strong>
          <RadioGroup
            row
            value={String(groupedColumnMode)}
            onChange={(event) => {
              const value = event.target.value;
              setGroupedColumnMode(value === "false" ? false : value);
            }}
          >
            <FormControlLabel
              control={<Radio />}
              label='"reorder"'
              value="reorder"
            />
            <FormControlLabel
              control={<Radio />}
              label='"remove" (default)'
              value="remove"
            />
            <FormControlLabel value="false" control={<Radio />} label="false" />
          </RadioGroup>
        </FormControl>
      </div>
    </>
  );
};
export default MaterialTableTreeComponent;
